import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";

import Home from "@/pages/Home";
import Golfers from "@/pages/Golfers";
import AthleteProfile from "@/pages/AthleteProfile";
import Apply from "@/pages/Apply";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Sponsors from "@/pages/Sponsors";
import About from "@/pages/About";
import Dashboard from "@/pages/Dashboard";
import BrandAssets from "@/pages/BrandAssets";
import CookiePolicy from "@/pages/CookiePolicy";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import CookieConsent from "@/components/CookieConsent";

function AppShell() {
  const location = useLocation();

  // Synchronously detect OAuth callback before rendering routes
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/golfers" element={<Golfers />} />
          <Route path="/golfers/:id" element={<AthleteProfile />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/sponsors" element={<Sponsors />} />
          <Route path="/about" element={<About />} />
          <Route path="/brand" element={<BrandAssets />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
      <Footer />
      <CookieConsent />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppShell />
          <Toaster position="bottom-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
